module.exports = __webpack_public_path__ + "8bb8e08b719ca037b94bcb059f14f8a5.glb";